import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";
import CommonSelect from "../../common/components/CommonSelect";
import { IntentOutCome } from "../../common/const";

const ProjectGoal = ({
    formData,
    handleInputChange,
    errors
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#F9CDE6"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Project Goals</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Project Goals</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Primary Goal of This Project"
                            type="email"
                            name="primaryGoal"
                            value={formData.primaryGoal}
                            onChange={handleInputChange}
                            placeholder="What do you hope to achieve through this project?"
                            error={errors.primaryGoal}
                            multiline
                        />
                    </Grid>
                    <Grid item md={6}>
                        <CommonFormField
                            label="Target Colleges/Majors"
                            type="email"
                            name="targetCollege"
                            value={formData.targetCollege}
                            onChange={handleInputChange}
                            placeholder="e.g. MIT"
                            error={errors.targetCollege}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <CommonSelect
                            label="Inteded Outcome"
                            name="intendedOutcome"
                            value={formData.intendedOutcome}
                            onChange={handleInputChange}
                            placeholder="Select an outcome"
                            options={IntentOutCome}
                            error={errors.intendedOutcome}
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default ProjectGoal;